/* eslint-disable no-param-reassign */
/* eslint-disable prefer-const */
/* eslint-disable no-continue */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-explicit-any */
import IconClose from '@assets/icons/close.svg?react';
import IconCheckWhite from '@assets/icons/check-white.svg?react';
import IconEmpty from '@assets/icons/empty.svg?react';
import {
 Box,
 Button,
 Card,
 CardContent,
 IconButton,
 Typography,
 useTheme,
} from '@mui/material';
import { Dispatch, MutableRefObject, SetStateAction } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CustomGridApi } from '../XTable/types';
import FilterFields from './FilterFields';
import useFilterSidebar from './useFilterSidebar';

interface FilterSidebarProps {
 apiRef: MutableRefObject<CustomGridApi>;
 isOpen: boolean;
 handleClose: Dispatch<SetStateAction<boolean>>;
 setColModalOpen: Dispatch<SetStateAction<boolean>>;
}

const FilterSidebar = (props: FilterSidebarProps) => {
 const { t } = useTranslation();
 const th = useTheme();
 const { apiRef, isOpen, handleClose, setColModalOpen } = props;

 const {
  applyFilters,
  resetFilters,
  methods,
  columns,
  dateRangeColumns,
  currentColumnsPreset,
  structure,
  isFormChanged,
 } = useFilterSidebar({ apiRef });

 return !isOpen ? null : (
  <Box
   sx={{
    width: isOpen ? { xs: '100%', md: '320px' } : '0px',
    transition: 'all 0.2s ease-in-out',
    marginLeft: isOpen ? { xs: '0px', md: '16px' } : '0px',
    overflowY: 'auto',
    position: 'relative',
   }}
  >
   <FormProvider {...methods}>
    <Card sx={{ height: '100%' }}>
     <CardContent
      component="form"
      onSubmit={methods.handleSubmit(applyFilters)}
      sx={{
       p: 0,
       fontSize: '12px',
       height: '100%',
       display: 'flex',
       flexDirection: 'column',
       pb: 3,
      }}
     >
      <Box sx={{ overflowY: 'auto', px: 3, flex: 1 }}>
       <Box
        sx={{
         display: 'flex',
         alignItems: 'center',
         justifyContent: 'space-between',
         py: '20px',
         width: '100%',
        }}
       >
        <Typography
         sx={{
          fontSize: { xs: 14, md: 16 },
          fontWeight: 500,
          lineheight: 'initial',
         }}
        >
         {t('global.filters')}
        </Typography>
        <IconButton
         onClick={() => handleClose(false)}
         sx={{
          position: 'relative',
          p: 0,
          top: { xs: 0, md: -8 },
          right: { xs: 0, md: -8 },
         }}
        >
         <IconClose
          style={{ width: 20, height: 20, color: th.palette.kemek.darkestGray }}
         />
        </IconButton>
       </Box>
       <FilterFields
        apiRef={apiRef}
        applyFilters={applyFilters}
        resetFilters={resetFilters}
        setColModalOpen={setColModalOpen}
        columns={columns}
        dateRangeColumns={dateRangeColumns}
        currentColumnsPreset={currentColumnsPreset}
        structure={structure}
        isFormChanged={isFormChanged}
       />
      </Box>

      {!!Object.keys(currentColumnsPreset?.filters?.fields || {}).length && (
       <Box
        sx={{
         display: 'flex',
         //  alignItems: 'center',
         justifyContent: 'space-between',
         gap: '12px',
         px: 3,
         pt: 2,
        }}
       >
        <Button
         variant="outlined"
         color="secondary"
         size="large"
         endIcon={<IconEmpty style={{ color: th.palette.kemek.lightGray }} />}
         onClick={() => {
          resetFilters();
         }}
         sx={{ flex: 1 }}
        >
         {t('global.reset')}
        </Button>
        <Button
         type="submit"
         size="large"
         variant="contained"
         disabled={!isFormChanged}
         endIcon={
          <IconCheckWhite
           style={{ color: th.palette.kemek.white, width: 16, height: 11 }}
          />
         }
         // autoFocus
         sx={{ flex: 1 }}
        >
         {t('global.apply')}
        </Button>
       </Box>
      )}
     </CardContent>
    </Card>
   </FormProvider>
  </Box>
 );
};
export default FilterSidebar;

